import { getTreatments } from '../../split/splitSelectors';

export const getPropertyPageRecommendationsTreatment = (state) => {
  return getTreatments(state)?.property_page_recommendations?.treatment;
};
